export const TECH_STACK_ROW_SIZE = 3;
export const PROJECTS_CAROUSEL_IMG_TRANSITION_TIMER_MILLIS = 4000;

export const MONTHS_COMPACT = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];